import gql from "graphql-tag";

export const MY_HR_GET_GENDERS = gql`
  query genders {
    genders {
      code
      name
    }
  }
`;
